import type { EventSourceMessage } from '@microsoft/fetch-event-source';
import { backgroundShipmentResultReceived } from 'src/infra/stores/reducer/sseSlice';
import type { AppDispatch } from 'src/infra/stores/store';

/**
 * Handle SSE BACKGROUND_SHIPMENT_RESULT events
 * Processes shipment recalculation results that were previously retrieved via polling
 */
export const handleBackgroundShipmentResultEvent = (event: EventSourceMessage, dispatch: AppDispatch): void => {
  try {
    const data = JSON.parse(event.data);

    if (data?.result) {
      dispatch(
        backgroundShipmentResultReceived({
          shipmentInvoiceId: data.shipmentInvoiceId,
          invoiceId: data.invoiceId,
          result: data.result,
        })
      );
    }
  } catch (error) {
    console.error('❌ SSE: Error parsing BACKGROUND_SHIPMENT_RESULT event:', error);
  }
};
